import React from 'react';
import { Moeda } from '../../utils/orcamentoPagamento';

const formatter = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

interface CurrencyInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'> {
  value: number;
  onChange: (value: number) => void;
  moeda?: Moeda;
}

/**
 * Campo de valor (€ ou R$) com máscara "caixa registradora": os dígitos digitados entram pelos
 * centavos (5 → 0,05; 500 → 5,00; 123456 → 1.234,56). 0 fica vazio, com o placeholder.
 */
const CurrencyInput: React.FC<CurrencyInputProps> = ({
  value,
  onChange,
  moeda = 'EUR',
  className = '',
  placeholder = '0,00',
  ...rest
}) => {
  const display = value ? formatter.format(value) : '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 12);
    onChange(digits ? parseInt(digits, 10) / 100 : 0);
  };

  return (
    <div className="relative">
      <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-gray-500">{moeda === 'BRL' ? 'R$' : '€'}</span>
      <input
        {...rest}
        type="text"
        inputMode="numeric"
        value={display}
        placeholder={placeholder}
        onChange={handleChange}
        className={`${className} ${moeda === 'BRL' ? 'pl-9' : 'pl-7'} text-right tabular-nums`}
      />
    </div>
  );
};

export default CurrencyInput;
